import { Menu, styled } from '@mui/material';

import LogoIcon from '@common/assets/LogoWithoutText.svg';

export const StyledLogoSectionWrap = styled('div', {
	shouldForwardProp: (prop) => prop !== 'isOpen',
})<{ isOpen: boolean }>(({ isOpen, theme }) => ({
	display: 'flex',
	alignItems: 'center',
	gap: '8px',
	transition: 'all .3s',
	borderRadius: '20px 20px 0px 0px',
	background: isOpen ? '#fff' : 'transparent',
	paddingInline: '8px',
	cursor: 'pointer',
	minWidth: '130px',
	[theme.breakpoints.down('sm')]: {
		minWidth: 0,
		flex: 1,
		gap: '6px',
		paddingInline: '4px',
		'& > svg, & > img': {
			width: '28px',
			minWidth: '28px',
			maxWidth: '28px',
			height: '28px',
			flexShrink: 0,
		},
		'& .MuiTypography-root': {
			fontSize: '14px',
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
		},
	},
}));

export const StyledLogoSectionServiceWrap = styled('div')({
	display: 'flex',
	alignItems: 'center',
	minWidth: '0px',
});

export const LogoImage = styled('img')({
	flexShrink: 1.5,
	height: '32px',
	minWidth: '32px',
	marginBlock: '3px',
	objectFit: 'contain',
});

export const StyledLogoSectionMenu = styled(Menu)({
	'& .MuiPopover-paper': {
		borderRadius: '0px 0px 20px 20px',
		background: '#FFF',
		boxShadow: '7px 35px 30px 0px #827D8326',
	},
	'& .MuiMenuItem-root': {
		gap: '8px',
		paddingInline: '4px',
	},
});

export const StyledLogoSectionServiceImage = styled('img')({
	maxHeight: '100%',
	minWidth: '24px',
	height: '24px',
	aspectRatio: '1 / 1',
});

export const Logo = styled(LogoIcon)({
	height: '32px',
	width: '32px',
	minWidth: '32px',
});
